import icon from 'scoreboard/components/icon'
import _ from 'lodash'

function colorIcon (color, opts={}) {
	if (color === 'performance' || color === 'performance-grayscale') {
		return icon(color + '-circle', 'color-icon icon-circle-fill')
	}

	const iconType = _.isNil(opts.icon) ?
		'circle-fill' : opts.icon
	return icon(iconType, 'color-icon ' + (color ? color : ''), opts)
}

export default colorIcon

colorIcon.__filename__ = 'components/color-icon.js'
